module.exports = __webpack_public_path__ + "34bc775d/img/lock-icon.bb9c7166.svg";